
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otsi/[search]",
      function () {
        return require("private-next-pages/otsi/[search]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/otsi/[search]"])
      });
    }
  